import { ReactNode } from 'react';
import * as Dialog from '@radix-ui/react-dialog';
import * as VisuallyHidden from '@radix-ui/react-visually-hidden';

import CloseIcon from 'assets/icons/close.svg';

import * as S from './Modal.styles';

type Props = {
  isOpen: boolean;
  onClose: () => void;
  children: ReactNode;
  maxWidth?: number;
  title?: string;
};

export const Modal = (props: Props) => {
  return (
    <Dialog.Root open={props.isOpen} onOpenChange={(open) => !open && props.onClose()}>
      <Dialog.Portal>
        <S.Overlay />
        <S.Content $maxWidth={props.maxWidth}>
          <VisuallyHidden.Root>
            <Dialog.Title>{props.title || 'Modal'}</Dialog.Title>
          </VisuallyHidden.Root>
          <S.CloseButton onClick={props.onClose}>
            <CloseIcon />
          </S.CloseButton>
          {props.children}
        </S.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
};
